import { Box, Stack, Typography } from '@mui/material';
import { AttachmentCard } from '@/components/shared/attachment-card';
import {
  AcademicStatusSource,
  type AcademicStatus,
} from '@/models/learning/academic-situation';
import { formatShortDate } from '@/utils/format-date';
import { StatusOptionsMenu } from './status-options-menu';

interface TimelineItemProps {
  status: AcademicStatus;
  isLast: boolean;
  onDelete: (statusId: number) => void;
}

export const TimelineItem = ({
  status,
  isLast,
  onDelete,
}: TimelineItemProps) => {
  const isManual = status.source === AcademicStatusSource.ManualInsertion;

  return (
    <Stack direction="row" spacing={2}>
      <Stack alignItems="center" flexShrink={0} pt={0.5}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: 'neutral.400',
          }}
        />
        {!isLast && (
          <Box
            flex={1}
            mt={0.5}
            sx={{
              width: '1px',
              backgroundColor: 'neutral.200',
            }}
          />
        )}
      </Stack>

      <Stack flex={1} spacing={1.5} pb={isLast ? 0 : 3} minWidth={0}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
          spacing={1}
        >
          <Box minWidth={0}>
            <Typography variant="h3">{status.title}</Typography>
            {status.subtitle && (
              <Typography color="neutral.600">{status.subtitle}</Typography>
            )}
          </Box>
          <Stack direction="row" alignItems="center" spacing={0.5} flexShrink={0}>
            <Typography variant="body2" color="neutral.500" whiteSpace="nowrap">
              {formatShortDate(status.occurred_at)}
            </Typography>
            {isManual && (
              <StatusOptionsMenu onDelete={() => onDelete(status.id)} />
            )}
          </Stack>
        </Stack>

        {status.documents.map((document) => (
          <AttachmentCard key={document.url} document={document} />
        ))}
      </Stack>
    </Stack>
  );
};
